<template>
    <div>
        <b-card>
            <div slot="header">
                <i class="fa fa-list-ul" aria-hidden="true"></i>
                    Floors list
                <div class="card-header-actions">
                    <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
                    <small class="text-muted">docs</small>
                    </a>
                </div>
            </div>
            <b-row>
                <b-col sm="12">
                    <alert-fail :show="'' != errorMessage"> {{ errorMessage }} </alert-fail>
                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :current-page="pagination.currentPage"
                          :per-page="pagination.numberPerPage"
                          class="table-privilege"
                          tbody-class="tbody" hover
                          thead-tr-class="thead-news"
                          @row-clicked="viewDetails"
                          selectable
                          selectedVariant="single"
                          :fields="fields"
                          :items="floors">
                          <template slot="#" slot-scope="row">
                              {{ row.index + 1 }}
                          </template>
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <b-row>
                    <b-col>
                        <app-paging
                            :totalRows="pagination.totalRows"
                            :page="pagination.currentPage"
                            @changePage="changePage"/>
                    </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import AppPaging from '../../components/Pagination.vue';
import AlertFail from '../../components/alert/AlertFail';
import { OptionList } from '../../models/option-list';

export default {
  data () {
    return {
      errorMessage: '',
      isBusy: false,
      isLoading: false,
      floors: [],
      fields: [
        { key: '#' },
        { key: 'name' }
      ],
      pagination: {
        currentPage: 1,
        numberPerPage: process.env.VUE_APP_NUMBER_PER_PAGE,
        totalRows: 30
      },
      optionList: new OptionList(this.axios)
    };
  },
  methods: {
    viewDetails (e) {
      this.$router.push({ name: '101floors-details', params: { id: e.id } });
    },
    changePage (e) {
      this.pagination.currentPage = e;
      this.getData();
    },
    handleError (error) {
      this.errorMessage = error.response ? error.response.data : error.message;
    },
    getData () {
      this.isBusy = true;
      this.optionList.loadFloors()
        .then(response => {
          if (response === []) {
            throw new Error('cannot get data');
          }
          const data = response;
          this.pagination.totalRows = data.length;
          data.forEach(floor => {
            this.floors.push({
              id: floor.code,
              name: floor.label
            });
          });
          this.isBusy = false;
        })
        .catch(error => {
          this.handleError(error);
        });
    }
  },
  computed: {
    totalRows () {
      return this.floors.length;
    }
  },
  mounted () {
    this.getData();
  },
  components: {
    'app-paging': AppPaging,
    AlertFail
  }
};
</script>

<style scoped>
</style>
